import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.858.858a2 2 0 0 1 2.828 0L15 12.172 26.314.858a2 2 0 0 1 2.828 2.828L17.828 15l11.314 11.314a2 2 0 0 1-2.828 2.828L15 17.828 3.686 29.142a2 2 0 0 1-2.828-2.828L12.172 15 .858 3.686a2 2 0 0 1 0-2.828"
    }, null, -1)
  ]))]))
}
export default { render: render }